import React from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import InfoFilled from '@mui/icons-material/InfoRounded';
import { Section } from '../Section';
import { IconWrapper } from './Seller.style';
import { colorPalette } from '../../../../../colorPalette';
export const SellerDescription = ({ sellerDescription }) => {
    return (React.createElement(Section, null,
        React.createElement(Stack, { direction: "row", alignItems: "center", spacing: 1 },
            React.createElement(IconWrapper, null,
                React.createElement(InfoFilled, { sx: {
                        width: '16px',
                        height: '16px',
                        color: colorPalette.gray700,
                    } })),
            React.createElement(Typography, { sx: {
                    fontSize: '18px',
                    color: colorPalette.gray900,
                } }, "Qui sommes-nous ?")),
        React.createElement(Stack, null,
            React.createElement(Typography, { sx: {
                    paddingTop: '16px',
                    color: colorPalette.gray700,
                    fontSize: '14px',
                } }, sellerDescription === null || sellerDescription === void 0 ? void 0 : sellerDescription.description))));
};
